import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { refreshToken } from "src/engine/modules/session/actions/creators"
import { selectToken } from "src/engine/modules/session/selectors"
import popup, { PopupCanvas, PopupPanel } from "@infotech/uikit-popup-factory"
import { LoaderIcon, RightIcon, TasksDownloadIcon } from "@infotech/uikit-icons"
import tooltip from "@infotech/uikit-tooltip"
import Spin from "@infotech/uikit-spin"
import { Box } from "@infotech/uikit-grid"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { usePlanTemplates } from "./planHook"
import generateAndDownloadTemplates from "./reportGenerator"
import styles from "./styles.css"
import { useTypeTemplates } from "./typeHook"

const TooltipSpan = tooltip.span()

const TemplatesPopup = popup({
  on: `click`,
  placement: `bottom-left`,
})

const TemplatesTypePopup = popup({
  on: `hover`,
  placement: `right-top`,
})

const templatesTypes = [
  // { name: `Документ HTML`, value: `HTML` },
  { name: `Microsoft Excel (XLS)`, value: `XLS` },
  { name: `Документ PDF`, value: `PDF` },
]

let templatesData = []
let templatesPending = true

const TemplateOptions = ({ data, token, planId, closePopup, generate }) => {
  const generateData = {
    id: Number(planId),
    templateCode: data.code,
    templateId: data.id,
  }
  return (
    <PopupCanvas>
      <TemplatesTypePopup>
        <TemplatesTypePopup.Trigger>
          <Box
            loose
            flex
            className={styles.TemplatesOption}
            onClick={closePopup}
          >
            <Box loose className={styles.TemplatesName}>
              <span>{data.name}</span>
            </Box>
            <Box loose className={styles.TemplatesArrow}>
              <RightIcon />
            </Box>
          </Box>
        </TemplatesTypePopup.Trigger>
        <TemplatesTypePopup.Content>
          <Box
            loose
            flex
            column
            className={styles.TemplateTypes}
            pt="2md"
            pb="2md"
          >
            {templatesTypes.map(type => (
              <>
                <Box
                  loose
                  pt="1md"
                  pb="1md"
                  pl="2md"
                  className={styles.TemplateTypesOption}
                  onClick={() => {
                    closePopup()
                    generateAndDownloadTemplates(
                      token,
                      generateData,
                      type.value,
                      generate,
                    )
                  }}
                >
                  <span>{type.name}</span>
                </Box>
              </>
            ))}
          </Box>
        </TemplatesTypePopup.Content>
      </TemplatesTypePopup>
    </PopupCanvas>
  )
}

TemplateOptions.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    code: PropTypes.string,
  }).isRequired,
  token: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
  closePopup: PropTypes.func.isRequired,
  generate: PropTypes.func.isRequired,
}

const TemplatesIcon = ({ haveTemplates }) =>
  haveTemplates ? (
    <TooltipSpan
      tooltip="В плане нет шаблонов"
      tooltipConfig={{
        placement: `bottom`,
      }}
    >
      <TasksDownloadIcon className={styles.iconDisabled} />
    </TooltipSpan>
  ) : (
    <TemplatesPopup.Trigger>
      <span>
        <TasksDownloadIcon />
      </span>
    </TemplatesPopup.Trigger>
  )

TemplatesIcon.propTypes = {
  haveTemplates: PropTypes.bool,
}

TemplatesIcon.defaultProps = {
  haveTemplates: false,
}

const TemplatesMenu = ({ currentToken, planId, planTypeId }) => {
  const [generatePending, setGeneratePending] = useState(false)
  const planTemplates = usePlanTemplates(currentToken, planId)
  const typeTemplates = useTypeTemplates(currentToken, planTypeId)

  const planTemplatesData = get(planTemplates, `data`) || []
  const typeTemplateData = get(typeTemplates, `data`) || []

  if (isEmpty(planTemplatesData)) {
    templatesData = typeTemplateData
    templatesPending = Boolean(typeTemplateData) && typeTemplateData.pending
  } else {
    templatesData = planTemplatesData
    templatesPending = Boolean(planTemplatesData) && planTemplatesData.pending
  }

  return (
    <div>
      {generatePending ? (
        <Box loose className={styles.TemplatesLoading}>
          <Spin duration="fast">
            <LoaderIcon color="#2880ff" />
          </Spin>
        </Box>
      ) : (
        <PopupCanvas>
          <TemplatesPopup>
            <TemplatesIcon haveTemplates={isEmpty(templatesData)} />
            <TemplatesPopup.Content>
              {({ placement, hide }) => (
                <PopupPanel placement={placement}>
                  <Box
                    pt="7px"
                    pb="1md"
                    loose
                    flex
                    column
                    className={styles.TemplatesWrapper}
                  >
                    {templatesPending ? (
                      <Box loose className={styles.TemplatesLoading}>
                        <Spin duration="fast">
                          <LoaderIcon color="#2880ff" />
                        </Spin>
                      </Box>
                    ) : (
                      Array.isArray(templatesData) &&
                      templatesData.map(item => (
                        <TemplateOptions
                          data={item}
                          closePopup={hide}
                          token={currentToken}
                          planId={planId}
                          planTypeId={planTypeId}
                          generate={setGeneratePending}
                        />
                      ))
                    )}
                  </Box>
                </PopupPanel>
              )}
            </TemplatesPopup.Content>
          </TemplatesPopup>
        </PopupCanvas>
      )}
    </div>
  )
}

TemplatesMenu.propTypes = {
  currentToken: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
  planTypeId: PropTypes.string.isRequired,
}

export default connect(
  state => ({
    currentToken: selectToken(state),
  }),
  {
    refreshToken,
  },
)(TemplatesMenu)
